var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.528,
    height: 14.938,
    viewBox: "0 0 13.528 14.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".svgicon-share-a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgicon-share-a",
    d: "M15.767,13.678a2.054,2.054,0,0,0-1.47.563L8.909,11.126a2.524,2.524,0,0,0,.075-.526,2.523,2.523,0,0,0-.075-.526L14.222,7a2.255,2.255,0,1,0-.716-1.652,2.509,2.509,0,0,0,.075.526L8.268,8.949a2.268,2.268,0,0,0-1.545-.6A2.231,2.231,0,0,0,4.5,10.6a2.269,2.269,0,0,0,3.806,1.652l5.351,3.115a1.883,1.883,0,0,0-.075.488,2.186,2.186,0,1,0,2.186-2.177Z",
    transform: "translate(-4.5 -3.094)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ce7ea449.svg";
export { ForwardRef as ReactComponent };